<template>
  <section class="container">
    <div class="tt">
      <h1>Cooperative Partner</h1>
      <div class="cate_list">
        <div v-for="(item, index) in cate" :key="index" :class="{ active: activeIndex == index }"
          @click="() => (activeIndex = index)">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="list">
      <div v-for="item in list" :key="item.id" class="item animate__animated animate__fadeInUp">
        <img :src="$baseURL + item.thumb" :alt="item.title" />
      </div>
      <Loading v-show="loading"></Loading>
    </div>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      loading: false,
      activeIndex: 0,
      cate: [],
      list: [],
    };
  },
  methods: {
    async aboutPartners(industry_id = "") {
      this.loading = true;
      let res = await service.aboutPartners({ industry_id });
      this.loading = false;
      if (res.code == 1) {
        this.cate = res.data.industrylist;
        this.list = res.data.partners;
      }
    },
  },
  created() {
    this.aboutPartners();
  },
  watch: {
    activeIndex(newVal) {
      this.aboutPartners(this.cate[newVal].id);
    },
  },
};
</script>

<style lang="less" scoped>
section {
  .tt {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      font-size: 30px;
    }

    .cate_list {
      display: flex;

      &>div {
        cursor: pointer;
        color: #666;
        transition: all 0.3s;

        &.active {
          color: var(--themeColor);
          font-weight: bold;
        }

        &+div {
          margin-left: 30px;
        }
      }
    }
  }

  .list {
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    position: relative;

    .item {
      height: 17vw;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }

      &:not(:nth-child(4n + 1)) {
        border-left: 1px dashed #004998;
      }

      &:nth-child(n + 5) {
        border-top: 1px dashed #004998;
      }
    }
  }
}

@media (max-width: 900px) {
  section {
    .tt {
      display: block;

      .cate_list {
        margin-top: 20px;
        flex-wrap: wrap;

        &>div {
          margin-top: 10px;
        }
      }
    }
  }
}

@media (max-width: 450px) {
  section {
    .list {
      grid-template-columns: repeat(2, 1fr);
      border-left: 1px dashed #004998;
      border-top: 1px dashed #004998;

      .item {
        &:not(:nth-child(4n + 1)) {
          border-left: none;
        }

        &:nth-child(n + 5) {
          border-top: none;
        }

        border-right: 1px dashed #004998;
        border-bottom: 1px dashed #004998;
      }
    }
  }
}
</style>